<template>
  <CrudList
    title="Proveedores"
    storeName="Providers"
    labelAddNew="Agregar"
    slot-scope="{ item }"
    sortable
    :canShow=true
    :canSearch="user && user.user_role !== 'provider'"
    :can-add="user && user.user_role !== 'provider'"
    :can-delete="user && user.user_role !== 'provider'"
  >
    <template v-slot:profile_picture="{ item }">
      <v-row align="center" justify="center">
        <v-col cols="12">
          <v-list-item-avatar v-if="item.profile_picture">
            <img :src="item.profile_picture" alt="" />
          </v-list-item-avatar>
        </v-col>
      </v-row>
    </template>

    <template v-slot:new_review="{item}">
      <v-btn
          class="my-2"
          color="primary"
          @click="$router.push('/admin/providers/' + item.id + '/reviews')"
      >Reseñas
      </v-btn>
    </template>

  </CrudList>
</template>

<script>
import CrudList from "@/components/Crud/CrudList";
import { mapState } from "vuex";

export default {
  components: { CrudList },
  computed: {
    ...mapState({
      user: state => state.Authenticate.user
    })
  }
};
</script>
